import script from "./kalio-user-profile.vue?vue&type=script&setup=true&lang=ts"
export * from "./kalio-user-profile.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__